<template>
  <div
    class="wrap is-overwrap"
    :class="{ 'show-side': showSideNav, 'has-side': hasSideNav }"
    v-if="showPrivacy"
  >
    <h2 class="hdg2">
      <span>個人情報保護方針</span>
      <div class="btn_return">
        <a @click.prevent="hidePrivacy" class="btn btn-primary">戻る</a>
      </div>
    </h2>
    <div class="container-fluid content_privacy">
      <p>日東電工ベースマテリアル株式会社およびＮｉｔｔｏグループ各社（以下、総称して「当社」といいます）は、 当社ウェブサイト及び当社ウェブサイトを通じて当社が提供するサービス（以下「本サービス」といいます）を介してお客様からご提供いただく個人情報（当該情報に含まれる氏名、住所、電話番号、所属団体名、電子メールアドレスなどからお客様を特定できる情報のことをいい、他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含みます 。以下「個人情報」といいます）を、本個人情報保護ポリシーに従い取り扱います。</p>
      <ol>
        <li>当社は、お客様の個人情報を取得、保有、使用する場合において、お客様の利益を損なうことのないよう努めます。</li>
        <li>当社は、お客様の個人情報を、下記の利用目的で取得し、当該目的の範囲内で個人情報を使用いたします。
          <ul>
            <li>(1) お客様の会員登録、ご注文・支払いの処理、商品の配送、取引履歴管理、当社ウェブサイト・本サービスの運営に関する連絡等、本サービスの提供、維持、保護及び改善のため</li>
            <li>(2) お客様に対する、郵送、ファクシミリまたは電子メールによる当社製品やサービス、キャンペーンの広告宣伝等、お客様に有用な情報の提供のため</li>
            <li>(3) 当社ウェブサイト及び本サービスに対するお客様からのお問い合わせ、要望、苦情等に対する対応を行うため</li>
            <li>(4) 当社ウェブサイトの改善や向上のため</li>
            <li>(5) マーケティングのためのデータの収集、当該データを分析して販売促進、サービス改善に役立てるため</li>
            <li>(6) 上記の利用目的に付随する利用目的のため</li>
          </ul>
        </li>
        <li>
          当社は、個人情報の毀損、滅失、紛失、改ざん、漏洩、目的外使用のないよう適切な管理体制を確立し、第三者に漏洩しないように努めます。
        </li>
        <li>当社は、Nittoグループとしての経営管理業務の遂行ならびに前条の利用目的の範囲内で、グループ会社間で、個人情報を共同して利用することがあります。
          <ul>
            <li>(1) 共同利用する個人データの項目<br>当社が保有するお客様の情報（氏名、住所、電話番号、所属団体名、電子メールアドレス、お客様の購買履歴その他当社ウェブサイトを通じて当社が受領したお客様とのお取引に関する情報）。</li>
            <li>(2) 共同利用者の範囲および管理責任者<br>共同利用するグループ会社の範囲は、日東電工株式会社およびその国内外の子会社で、また、将来子会社となる者を含みます。なお、共同利用の管理責任者は、日東電工ベースマテリアル株式会社とします。
            </li>
          </ul>
        </li>
        <li>当社は、個人情報の毀損、滅失、紛失、改ざん、漏洩、目的外使用のないよう適切な管理体制を確立し、第三者に漏洩しないように努めます。
          <ul>
            <li>(1) 当社は、個人情報の毀損、滅失、紛失、改ざん、漏洩、目的外使用のないよう適切な管理体制を確立し、第三者に漏洩しないように努めます。</li>
            <li>(2) 人の生命、身体又は財産の保護のために必要であって、お客様の同意を得ることが困難な場合</li>
            <li>(3) 国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、お客様の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合</li>
          </ul>
        </li>
        <li>当社は、お客様からご要望をいただいた場合、下記の手続きに従い、開示・訂正・利用停止いたします。（個人情報の保護に関する法律（以下「個人情報保護法」といいます。）その他の法令により、当社が開示・訂正・利用停止等の義務を負わない場合を除きます。）
          <ul>
            <li>(1) 個人情報の開示<br>
            当社は、お客様から、個人情報保護法の定めに基づき個人情報の開示を求められたときは、お客様ご本人からの請求であることを確認の上で、お客様に対し、遅滞なく開示を行います（当該個人情報が存在しないときにはその旨を通知いたします。）。但し、個人情報保護法その他の法令により、当社が開示の義務を負わない場合は、この限りではありません。なお、個人情報の開示につきましては、手数料（1件あたり１０００円
            ）を頂戴しておりますので、あらかじめ御了承ください。</li>
            <li>(2) 個人情報の訂正及び利用停止等<br>
            当社は、お客様から、⑴個人情報が真実でないという理由によって個人情報保護法の定めに基づきその内容の訂正を求められた場合、及び⑵あらかじめ公表された利用目的の範囲を超えて取り扱われているという理由または偽りその他不正の手段により収集されたものであるという理由により、個人情報保護法の定めに基づきその利用の停止を求められた場合には、お客様ご本人からの請求であることを確認の上で遅滞なく必要な調査を行い、その結果に基づき、個人情報の内容の訂正または利用停止を行い、その旨をお客様に通知します。なお、合理的な理由に基づいて訂正または利用停止を行わない旨の決定をしたときは、お客様に対しその旨を通知いたします。当社は、お客様から、お客様の個人情報について消去を求められた場合、当社が当該請求に応じる必要があると判断した場合は、お客様ご本人からの請求であることを確認の上で、個人情報の消去を行い、その旨をお客様に通知します。</li>
          </ul>
        </li>
        <li>本サイトは、安全性の高い技術を使用し、セキュリティーを高く保つことによってお客様の個人情報を守っています。</li>
        <li>当社は、お客様の個人情報の保護に関係する法律等を遵守するとともに、法律等の施行や改定または社会情勢の変化に合わせて、本個人情報保護ポリシーの改善に鋭意努めます。これに伴い、本ポリシーが予告無く変更することがありますことを予めご了承ください。</li>
        <li>本個人情報保護ポリシーに関するお問い合わせは、
        <a
          href="#"
          @click.prevent="
            submitNewTabAsteria(
              'Inquiry',
              'loadHTML_forInquiry',
              {},
              '',
              '/inquiry/inquiry.html'
            )
          "
            >「お問い合わせ」メールフォーム</a>よりご連絡をお願いいたします。</li>
      </ol>
    </div>
  </div>
</template>

<script>
import {
  store as BootstrapStore,
  mutations as BootstrapMutations
} from "../store/Bootstrap";

export default {
  computed: {
    showPrivacy() {
      return BootstrapStore.showPrivacy;
    },
    showSideNav() {
      return BootstrapStore.showSideNav;
    },
    hasSideNav() {
      return BootstrapStore.hasSideNav;
    }
  },
  methods: {
    hidePrivacy() {
      BootstrapMutations.hidePrivacy();
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-primary {
  color: #fff !important;
}
.wrap {
  z-index: 999;
}
</style>
